// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1cVbM","rightAdornment":"Header_rightAdornment__1M41s"};